var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMutation } from '@tanstack/react-query';
import { apiResponseType } from '@repo/shared/types';
import { ApiClient, apiPaths } from '@repo/api/client';
var apiEndpoint = apiPaths.event.click;
function postEventClick(payload) {
    return ApiClient.fetch(apiEndpoint.path, {
        options: { method: 'POST', body: JSON.stringify(payload) },
        skipValidation: true,
    });
}
export function usePostEventClick() {
    return useMutation({
        retry: false,
        mutationFn: function (payload) {
            return postEventClick(__assign(__assign({}, payload), { type: apiResponseType.enum.EVENT_CLICK, timestamp: new Date().toISOString() }));
        },
    });
}
